import { EMPTY_VALUE } from '../constants/styles';

/**
 * Показывает порог близости: до двух знаков после запятой, разделитель — по языку системы.
 * Незаданный порог показывается прочерком — как и любая величина, которой ещё нет.
 */
export const formatThreshold = (value: number | undefined): string =>
  value === undefined ? EMPTY_VALUE : value.toLocaleString(undefined, { maximumFractionDigits: 2 });
